
<div class="legend">
    <span>📌 Los días festivos están marcados con este ícono:</span>
    <img src="assets/img/logo.png" alt="Día festivo" class="legend-icon">
  </div>
<full-calendar [options]="calendarOptions"></full-calendar>
